import { render, staticRenderFns } from "./ModalLossCompensationInfo.vue?vue&type=template&id=1cec97d2&"
import script from "./ModalLossCompensationInfo.vue?vue&type=script&lang=js&"
export * from "./ModalLossCompensationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports